<template>
    <q-dialog v-model="showModal">
        <q-card style="width: 500px; max-width: 450vw;">
            <q-card-section>
                <div class="text-h6">{{$t('heads_up')}}!</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <p>{{$t('recipients.we_are_taking_you_to_the_recipients_page')}}</p>
                <p>{{$t('recipients.once_you_are_done_with_recipients_you_ll_need_to_start')}}</p>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn v-close-popup outline :label="$t('cancel')" color="primary" />
                <q-btn :label="$t('recipients.go_to_recipients')" color="primary" v-close-popup @click="$emit('do')"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

export default {
    name: "EditRecipientModal",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
